import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/2jyw0A8QSznCj0dRr92w/locations/uiHqDHLAHbh9HVvPmAQg`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="315px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/2jyw0A8QSznCj0dRr92w/locations/uiHqDHLAHbh9HVvPmAQg`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} w="300px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
